import { useMutation } from '@apollo/client';
import SignupForm from '@nile/banyan/src/Components/Public/SignupForm';
import { SignupClient } from '@nile/graphql';
import { SIGNUP_USER } from '@nile/banyan/src/Graphql/Mutations/auth';
import { Frame, Loading } from '@superops/ui-design-system';
import React from 'react';
import { withRouter } from 'react-router-dom';

let SignupContainer = (props) => {
  const [signUpUser, { loading, error }] = useMutation(SIGNUP_USER, {
    client: SignupClient,
    onCompleted({ signUpUser }) {
      if (signUpUser) {
        props.history.push('confirmemail');
      }
    }
  });

  if (loading)
    return (
      <Frame>
        <Loading />{' '}
      </Frame>
    );
  if (error) return <p>An error occurred</p>;
  return (
    <div>
      <SignupForm signUpUser={signUpUser}></SignupForm>
    </div>
  );
};

export default withRouter(SignupContainer);
